// extracted by mini-css-extract-plugin
export var carousel = "SectionSlider-module--carousel--fbccb";
export var controls = "SectionSlider-module--controls--0ff16";
export var mask = "SectionSlider-module--mask--57af3";
export var nextButton = "SectionSlider-module--next-button--fd3d6";
export var prevButton = "SectionSlider-module--prev-button--15ab3";
export var totalPages = "SectionSlider-module--total-pages--4a8d7";